<template>
    <div class="card">
        <div class="card-body p-5">
            <h4 class="mt-0 mb-0 text-center">Reply To This Ticket</h4>
            <div class="form-group">
                <textarea v-model="replyMessage" class="form-control" placeholder="Type Reply Here..."></textarea>
            </div>
          <div>
            <label>Attachment:</label>
            <input type="file" class="form-control" id="customFile" ref="file" @change="changeFile($event)">
          </div>
            <button class="btn btn-outline-primary btn-sm pull-right" :disabled="disabled" @click="doReply()">
                <div class="loader small_loader" v-if="disabled"></div>
                <span v-else>Reply</span>
            </button>
        </div>
    </div>
</template>

<script>
    import { functions } from "@/firebase/init"
    import swal from 'sweetalert2';
    export default {
        name: "TicketReplyBox",
        data() {
          return {
              replyMessage: '',
              disabled: false,
            event: null,
            file: null,
            base64: null,
            fileName: null
          }
        },
        props: {
            ticket: {
                type: Object
            },
            clientId: {
                required: false,
                default() {return 0;}
            },
            ticketFrom:{
                required: false,
                type: String,
                default() {return '';}
            }
        },
        computed:{
            user() {
                return this.$store.getters.user;
            },
          userToken() {
            return this.$store.getters.getUserToken;
          },
        },
        methods: {
          changeFile (event) {
            const self = this;
            this.file = event.target.files[0]
            this.event = event
            this.fileName = this.file.name
            // convert file into base64
            let reader = new FileReader();
            reader.readAsDataURL(this.file);
            reader.onloadend = async function () {
              console.log('in function')
              // Since it contains the Data URI, we should remove the prefix and keep only Base64 string
              self.base64 = await reader.result.replace(/^data:.+;base64,/, '');
              console.log(self.base64); //-> "R0lGODdhAQABAPAAAP8AAAAAACwAAAAAAQABAAACAkQBADs="
            };
          },
            async doReply(){
                if(this.replyMessage === ''){
                    swal('Not Valid', 'Please type valid reply', 'error');
                    return;
                }
                this.disabled = true;

              let formData = new FormData();

                console.log('out function')
                formData.append('clientId', this.clientId)
                formData.append('token', this.userToken)
                formData.append('grant_type', 'token')
                formData.append('ticketNumber', this.ticket.ticket_number)
                formData.append('message', this.replyMessage)
                formData.append('name', this.user.firstName + ' ' + this.user.lastName)
                formData.append('file', this.base64)
                formData.append('fileName', this.fileName)
                try {
                  const response = await this.$http.post('host-bill/reply-ticket',formData, {
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    },
                  })
                  if(response.data.success || (response.data.info && response.data.info.includes('reply_added'))){
                    this.addLog({
                      message: "Successfully replied to ticketID, " + this.ticket.ticket_number,
                      level:  "success"
                    })
                    swal('Added!', response.data.message, 'success');
                    if(this.ticketFrom===''){
                      this.$parent.fetchTicketDetail(this.ticket.ticket_number);
                    }else{
                      this.$parent.fetchTicketDetails();
                    }
                  }else{
                    swal('Error!', response.data.message, 'error');
                    this.addLog({
                      message: "Error in replying to ticketID, " + this.ticket.ticket_number,
                      level:  "error"
                    })
                  }
                } catch (e) {
                  console.log('error in replying ticket api')
                  console.log(e.toString())
                  this.addLog({
                    message: "Error in replying to ticketID, " + this.ticket.ticket_number,
                    level:  "error"
                  })
                }
                this.replyMessage = '';
                this.disabled = false;
                if (this.file) {
                  if (this.event) {
                    this.event.target.value = ''
                  }
                  this.file = null
                  this.base64 = null
                }
            }
        }
    }
</script>

<style scoped>

</style>
